import {Routes} from '@angular/router';
import {Error404ViewComponent} from './404/404';

export const ERROR_ROUTES: Routes = [
    {path: 'not-found', component: Error404ViewComponent }
];
